import { Skeleton, SkeletonProps } from 'components/Skeleton/Skeleton'
import Styles from './ImageSkeleton.module.scss'

export const ImageSkeleton = (props: Pick<SkeletonProps, 'loading'>) => (
  <Skeleton active paragraph={false} className={Styles.skeleton} {...props} />
)
